import { Store } from "vuex";
import ProjectWorker from "@/entities/project-worker";

export default interface ProjectWorkerOutputPort {
  info(workers: ProjectWorker[]): void;
  error(message: string): void;
}

export class VuexProjectWorkerPresenter {
  public constructor(private $store: Store<any>) {}

  public info(workers: ProjectWorker[]) {
    this.$store.commit("member/load-workers", workers);
  }

  public error(message: string) {
    alert(message);
  }
}
